"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

_core["default"].lang.en = _core["default"].lang.en || {};
_core["default"].lang.en.confirm = {
  yes: 'Yes',
  cancel: 'Cancel',
  textConfirm: 'Are you sure to do this ?'
};